<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('groupresource.pageTitleText') }}
            p Manage group resources and limits.
            strong(v-if="$store.getters.isAdmin") You have created {{ usage.used }} of {{ usage.max }} groups.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="$store.getters.isAdmin &&$store.state.queryGroupName == 'all'"
            :userCanIndex="true"
            :userCanDelete="$store.getters.isAdmin"
            :actionInTable="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            :primarySearchKey="$store.getters.isAdmin ? 'groupName' : ''"
            :primarySearchKeyI18="$t('groupresource.groupName')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','GroupResource')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','GroupResource')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','GroupResource')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import StringList from "@/components/StringList";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("StringList", StringList);

import { getGroupAsset } from "@/api/groupasset.js";

import { settingZoneExplain, groupName, slbs, edges, action } from "./fields.js";

export default {
    name: "GroupResource",
    components: { RcmTable, TagList },
    data() {
        return {
            esIndex: "rcm-edgegroup",
            drawerTitleKey: "groupName",
            assetCategory: "groupResources",
            usage: { used: "", max: "", available: "" },
        };
    },
    computed: {
        // platformMaxGroupCount() {
        //     const resourceLimits = this.$store.getters.resourceLimits;
        //     return resourceLimits.platformMaxGroupCount;
        // },
        addButtonText() {
            return this.$i18n.t("groupresource.createText");
        },
        sectionInfo() {
            let sectionInfo = [
                { sectionKey: "essential", isOpened: true },
                { sectionKey: "netflow", isOpened: true },
            ];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`groupresource.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
            // return [];
        },
        esIndexFields: {
            get() {
                return this.$store.getters.isAdmin
                    ? {
                          action: action(this),
                          groupName: groupName(this),
                          _id: {},
                          settingZoneExplain: settingZoneExplain(this),

                          createdFQDNConfigCount: {},
                          maxFQDNConfigCount: {},
                          paymentStatus: {},
                          FQDNConfigUsage: {},

                          maxServerNameInAppProfileCount: {},

                          createdAppProfileCount: {},
                          maxAppProfileCount: {},
                          appProfileUsage: {},

                          createdUserCount: {},
                          maxUserCount: {},
                          userUsage: {},

                          createdNonProfileServerNameCount: {},
                          // maxNonProfileServerNameCount: {},
                          // nonProfileServerNameUsage: {},

                          createdServerNameCount: {},
                          maxServerNameCount: {},
                          serverNameUsage: {},

                          createdWafRuleCount: {},
                          maxWafRuleCount: {},
                          groupMaxFQDNUsedWafCount: {},
                          groupMaxRulesInWafHeadersSet: {},
                          wafRuleUsage: {},
                          maxOwaspRuleCount: {},
                          maxOwaspRuleUsedFQDNCount: {},
                          maxRuleCountOfRewriteUrlRules: {},
                          maxRuleCountOfCacheRules: {},

                          createdAlertRuleCount: {},
                          maxAlertRuleCount: {},
                          alertRuleUsage: {},

                          createdHtmlPageCount: {},
                          maxHtmlPageCount: {},
                          htmlPageUsage: {},

                          createdOriginPolicyCount: {},
                          maxOriginPolicyCount: {},
                          originPolicyUsage: {},

                          maxDomainListenPortCount: {},
                          maxGroupListenPortCount: {},
                          maxDomainOriginCount: {},

                          //   useHttp2: {},
                          maxAssignSlbCount: {},
                          slbs: slbs(this),
                          maxAssignEdgeCount: {},
                          edges: edges(this),
                          netflowIpListV2: {},
                          netflowPercentile: {},
                          netflowTimestampAggregationInterval: {},

                          createdServiceGroupCount: {},
                          maxServiceGroupCount: {},
                          serviceGroupUsage: {},

                          status: {},
                          objectLog: {},
                          kafkaLogRate: {},
                          createdDate: {},
                          maxCertManageCount: {},
                          http2UpgradeList: {},
                      }
                    : {
                          action: action(this),
                          groupName: {},
                          _id: {},
                          settingZoneExplain: settingZoneExplain(this),

                          createdFQDNConfigCount: {},
                          maxFQDNConfigCount: {},
                          paymentStatus: {},
                          FQDNConfigUsage: {},

                          maxServerNameInAppProfileCount: {},

                          createdAppProfileCount: {},
                          maxAppProfileCount: {},
                          appProfileUsage: {},

                          createdUserCount: {},
                          maxUserCount: {},
                          userUsage: {},

                          createdNonProfileServerNameCount: {},
                          // maxNonProfileServerNameCount: {},
                          // nonProfileServerNameUsage: {},

                          createdServerNameCount: {},
                          maxServerNameCount: {},
                          serverNameUsage: {},

                          createdWafRuleCount: {},
                          maxWafRuleCount: {},
                          groupMaxFQDNUsedWafCount: {},
                          groupMaxRulesInWafHeadersSet: {},
                          wafRuleUsage: {},
                          maxOwaspRuleCount: {},
                          maxOwaspRuleUsedFQDNCount: {},
                          maxRuleCountOfRewriteUrlRules: {},
                          maxRuleCountOfCacheRules: {},

                          createdAlertRuleCount: {},
                          maxAlertRuleCount: {},
                          alertRuleUsage: {},

                          createdHtmlPageCount: {},
                          maxHtmlPageCount: {},
                          htmlPageUsage: {},

                          createdOriginPolicyCount: {},
                          maxOriginPolicyCount: {},
                          originPolicyUsage: {},

                          maxDomainListenPortCount: {},
                          maxGroupListenPortCount: {},
                          maxDomainOriginCount: {},

                          //   useHttp2: {},
                          maxAssignSlbCount: {},
                          slbs: slbs(this),
                          maxAssignEdgeCount: {},
                          edges: edges(this),
                          netflowIpListV2: {},
                          netflowPercentile: {},
                          netflowTimestampAggregationInterval: {},

                          createdServiceGroupCount: {},
                          maxServiceGroupCount: {},
                          serviceGroupUsage: {},

                          status: {},
                          objectLog: {},
                          kafkaLogRate: {},
                          createdDate: {},
                          maxCertManageCount: {},
                          http2UpgradeList: {},
                      };
            },
            set(value) {
                // console.log(value);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    beforeMount() {
        if (this.$store.state.platformPlan.isAllowSubscribeRawLogsClosing && this.$store.getters.isAdmin) {
            this.esIndexFields.isSubscribeRawLogs = {};
        }
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/GroupResource/Page.vue